import { uuid } from 'vue-uuid';
import _ from 'lodash';
import {
  computeBoundingBox,
  getUniqueGroupName,
  assignPdfSortOrderWithinGroup,
} from '@/components/Canvas/utils/groupHelpers';

export const createGroupObject = () => ({
  type:                    'group',
  Id:                      uuid.v1(),
  Name:                    'Group',
  X:                       0,
  Y:                       0,
  Width:                   100,
  Height:                  100,
  RotateDegree:            0,
  scaleX:                  1,
  scaleY:                  1,
  IsVisible:               true,
  locked:                  false,
  isSelected:              false,
  isGroupExpanded:         true,
  childCoords:             'absolute',
  PdfSortOrder:            0,
  elementIndex:            -1,
  PageNo:                  0,
  isEditableForRightPanel: false,
  children:                [],
  AllowMove:               'true',
  AllowResize:             'true',
  AllowRotate:             'true',
});

export const createGroupFromObjects = (objects, objectList = []) => {
  const children = objects.map((obj) => {
    const child = _.cloneDeep(obj);
    child.elementIndex = -1;
    child.isSelected = false;
    return child;
  });
  assignPdfSortOrderWithinGroup(children);
  const bbox = computeBoundingBox(children, { asGroupChild: true });

  return {
    type:                    'group',
    Id:                      uuid.v1(),
    Name:                    getUniqueGroupName(objectList),
    X:                       bbox.x,
    Y:                       bbox.y,
    Width:                   bbox.width,
    Height:                  bbox.height,
    RotateDegree:            0,
    scaleX:                  1,
    scaleY:                  1,
    IsVisible:               true,
    locked:                  false,
    isSelected:              false,
    isGroupExpanded:         true,
    childCoords:             'absolute',
    PdfSortOrder:            Math.max(...objects.map(o => o.PdfSortOrder || 0)),
    elementIndex:            -1,
    PageNo:                  objects[0].PageNo || 0,
    isEditableForRightPanel: false,
    children,
    AllowMove:               'true',
    AllowResize:             'true',
    AllowRotate:             'true',
  };
};

export default {
  createGroupObject,
  createGroupFromObjects,
};
